// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import CollapseTransition from './CollapseTransition';
import ArrowContent from '../assets/images/content-arrow.svg';

interface ToggleButtonProps extends ComponentPropsWithRef<'button'> {
  isOpen: boolean;
}

const S = {
  Button: styled.button<ToggleButtonProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    transition: all .5s;
    border-radius: 50%;
    cursor: pointer;
    filter: drop-shadow(0px 2px 4px #DEDEDE);

    &:hover{
      background-color: #DEDEDE;
    }

    img {
      transition: all .5s;
      transform: rotate(${props => props.isOpen ? 0 : 180}deg);
    }
  `,
  Img: styled.img``,
  Container: styled.div`
    position: relative;
  `,
  ToggleButton: styled(ToggleButton)`
    position: absolute;
    top: 0;
    right: 4px;
  `,
}

function ToggleButton(props: ToggleButtonProps): JSX.Element {
  return (
    <S.Button {...props}>
      <S.Img src={ArrowContent} alt="" />
    </S.Button>
  )
}

type RenderFunction = () => JSX.Element;

interface CollapseProps extends Omit<React.ComponentPropsWithRef<'div'>, 'title'> {
  title?: string | RenderFunction;
  isShow?: boolean;
}

const Collapse = (props: CollapseProps): JSX.Element => {
  const {
    title,
    isShow = true,
    children,
    ...otherProps
  } = props;

  const [visible, setVisible] = useState(isShow);

  useEffect(() => {
    setVisible(isShow);
  }, [isShow])

  const handleCollapse = () => {
    setVisible(!visible);
  }

  const renderTitle = () => {
    if (title === '' || title === undefined) {
      return null;
    } else if (typeof title === 'string') {
      return ((<h2>{title}</h2>))
    } else {
      return title()
    }
  }

  return (
    <S.Container {...otherProps}>
      {renderTitle()}
      <CollapseTransition visible={visible}>
        {children}
      </CollapseTransition>
      <S.ToggleButton onClick={handleCollapse} isOpen={visible} />
    </S.Container>
  )
}

export {
  Collapse as default,
  ToggleButton,
}
